import * as React from 'react';

import { VirtualPackErpResponse } from 'com.cogvio.pricemonitor.api';
import { ERPTooltip } from './ERPTooltip';

import classNames from 'classnames';
import { roundedHumanFormat } from '~/utils/Price/Price';

export const calculateModelRevenue = (model: VirtualPackErpResponse | null | undefined) =>
	model?.stats.cumulativeRevenues.reduce(
		(sum: null | number, data) => (data.revenue ? Number(sum || 0) + Number(data.revenue.value) : sum),
		null
	) || NaN;

export const renderModelRevenue = (model: VirtualPackErpResponse | null | undefined, currency: string) => {
	const revenueAggregator = calculateModelRevenue(model);

	return !isNaN(revenueAggregator) ? `${roundedHumanFormat(currency, revenueAggregator.toFixed(2))}` : 'NaN';
};

const ERPRevenuePriceBadge = ({
	currency,
	erpModelResult,
	type,
}: {
	currency: string;
	erpModelResult?: VirtualPackErpResponse | null;
	type?: 'big' | 'small';
}) => {
	const revenue = React.useMemo(() => renderModelRevenue(erpModelResult, currency), [erpModelResult, currency]);
	const isRevenueNaN = revenue === 'NaN';

	return (
		<span
			className={classNames(
				`mr-1 mb-0.5 inline-block px-3 py-1 rounded-sm font-display text-label font-medium leading-5 ${
					isRevenueNaN ? 'text-gray-400' : 'text-gray-800'
				} tracking-wider bg-cBlue-400 bg-opacity-10`,
				{
					'text-label': !type || type === 'big',
					'text-labelsmall': type === 'small',
				}
			)}
		>
			Revenue (4Y): <strong className='font-semibold tabular-nums'>{revenue}</strong>
			{isRevenueNaN && (
				<ERPTooltip>
					<span className='absolute left-full bottom-0 -mb-0.5 ml-1 px-1.5 py-1 rounded-sm font-display text-label text-white bg-black text-center whitespace-nowrap opacity-0 invisible group-hover:opacity-100 group-hover:visible'>
						Add Volume &amp; Growth data
					</span>
				</ERPTooltip>
			)}
		</span>
	);
};

export default React.memo(ERPRevenuePriceBadge);
